import React, { useEffect, useRef } from 'react'


import Loader from '../../components/Loader'
import Screen from '../../components/Screen'
import Table from '../../components/Table'
import useAuth from '../../hooks/useAuth'
import useFellowAdmin from '../../hooks/useFellowAdmin'
import NewAdmin from './NewAdmin'

const FellowAdmins = () => {
  const { user, isCompanyAdmin } = useAuth();
  const {
    deleteLoading,
    addLoading,
    loading,
    fellowAdmins,
    setData,
    fetchAdmins,
    removeAdmin,
    changeAdmin,
    newAdmin,
    data: fieldData,
  } = useFellowAdmin();
  
  const ref = useRef();

  const labels = [
    '#',
    'Name',
    'Email',
    'Status',
    !isCompanyAdmin && 'Actions'
  ];
  const data = fellowAdmins
    ?.map((item) => {
      return {
        data: item,
        fields: [
          item?._id?.substr(item?._id.length - 5),
          item.name,
          item.email,
          item.status ? 'Active' : 'InActive',
          <div className='d-flex gap-3'>
            {item.email == 'compcheck@warisconsulting.co.uk' ?null : <i
              onClick={() => {
                ref.current?.scrollIntoView();
                setData(item)
              }}
              className="bi bi-pencil-square text-primary" style={{ cursor: 'pointer' }}
            />}
            {
              user?._id == item?._id || item.email == 'compcheck@warisconsulting.co.uk' ? null :
                <Loader loading={deleteLoading?._id == item?._id} color='red'>
                  <i onClick={() => removeAdmin(item)} className="bi bi-trash text-danger" style={{ cursor: 'pointer' }}></i>
                </Loader>
            }
          </div>
        ]
      }
    })
  useEffect(() => {
    fetchAdmins({ hide: ['Default'] });
  }, []);

  return (
    <Screen loading={loading} flow={[
      { label: 'Fellow Admins', to: '/fellowAdmins' },
      { label: 'Home', to: '/' },
      { label: 'Fellow Admins', to: '/fellowAdmins' }
    ]}>
      <div ref={ref} className='row'>
        {<div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
          <NewAdmin
            data={fieldData}
            setData={setData}
            onSubmit={fieldData?._id ? changeAdmin : newAdmin}
            loading={addLoading}
          />
        </div>}
        <div className={`col-12 col-sm-12 col-md-12 col-lg-${isCompanyAdmin ? '8' : '8'} col-xl-${isCompanyAdmin ? '8' : '8'}`}>
          <Table
            title={'Fellow Admins'}
            data={data}
            labels={labels}
          />
        </div>
      </div>
    </Screen>
  )
}

export default FellowAdmins